/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OtherInformation.vue?vue&type=template&id=13398c94&scoped=true&"
import script from "./OtherInformation.vue?vue&type=script&lang=js&"
export * from "./OtherInformation.vue?vue&type=script&lang=js&"
import style0 from "./OtherInformation.vue?vue&type=style&index=0&id=13398c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13398c94",
  null
  
)

export default component.exports